import React, { FC } from "react";
import ButtonPrimary from "@/shared/Button/ButtonPrimary";
import HeroSearchForm from "@/components/HeroSearchForm/HeroSearchForm";
import LocationInput from "../HeroSearchForm/LocationInput";
import StayDatesRangeInput from "../HeroSearchForm/StayDatesRangeInput";
import { DateRage } from "../HeroSearchForm/StaySearchForm";
import { useNavigate } from "react-router-dom";
import { DATE_FORMAT } from "@/contains/contants";
import moment from "moment";
import { fireEvent } from "@/lib/utils";
import ButtonSecondary from "@/shared/Button/ButtonSecondary";
import Badge from "@/shared/Badge/Badge";
// import PageHomeMap from "@/containers/PageHome/PageHomeMap";

export interface SectionHeroProps {
  className?: string;
}

const SectionHero2: FC<SectionHeroProps> = ({ className = "" }) => {

  const [location, setLocation] = React.useState<string>('')
  const [dateRange, setDateRange] = React.useState<DateRage>({startDate:moment(),endDate:moment().add('1','month')})
  const navigate = useNavigate()

  return (
    <div
      className={`nc-SectionHero flex flex-col-reverse lg:flex-col relative ${className}`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-shrink-0 lg:w-1/2 flex flex-col items-start space-y-8 sm:space-y-4 pb-0 lg:pb-64 xl:pr-14 lg:mr-10 xl:mr-0">
          <h1 className="font-medium text-3xl md:text-4xl xl:text-5xl !leading-[114%] my-4">
          Outdoor & Digital Advertising Made Easy
          </h1>
          <h3 className="text-base md:text-lg text-neutral-500 dark:text-neutral-400">
          Discover thousands of verified billboard locations, compare rates, and launch your campaign in minutes. Adboard Booking connects advertisers, agencies, and media owners with real-time availability and smart campaign tools.
          </h3>
          <div className="bg-white w-full rounded-3xl lg:hidden">
            <LocationInput defaultValue={location} onChange={setLocation}/>
            <StayDatesRangeInput defaultValue={dateRange} onChange={setDateRange}/>
          </div>
          <div className="flex gap-4 py-4">
            <ButtonPrimary className="lg:hidden" onClick={()=>{
              fireEvent('hero.search.click')
              navigate('/billboards/'+location+'?startDate='+dateRange.startDate?.format(DATE_FORMAT)+'&endDate='+dateRange.endDate?.format(DATE_FORMAT)+window.location.hash)
            }}>Search Billboards</ButtonPrimary>
            <ButtonPrimary className="hidden lg:block" onClick={()=>{
              fireEvent('hero.search.click')
              const element=document.getElementById('HeroSearchForm')
              if(element?.offsetParent){
                const y = element.getBoundingClientRect().top + window.pageYOffset -100; 
                window.scrollTo({top: y, behavior: 'smooth'});
              }else{
                PubSub.publish('START_SEARCH_CLICK')
              } 
            }}>Start Booking Now</ButtonPrimary>
           
            <a href="https://pages.adboardbooking.com/surprise-billboard" target="_blank">
              <ButtonSecondary>
              See Ideas
              </ButtonSecondary>
            </a>
          </div>
          <div className="lg:flex gap-2 hidden">
            <Badge color="blue" name="90+ Screens Listed"/>
            <Badge color="blue" name="Live Monitoring Enabled"/>
            <Badge color="blue" name="Trusted by Advertisers"/>
            <br />
          </div>
          <Badge color="blue" name="Now Available for Birthdays & Proposals"/>
        </div>
        {/* <HeroSearchForm /> */}
        
        <div className="flex-grow mt-8 lg:mt-0 lg:block rounded-3xl overflow-hidden ">
          {/* <PageHomeMap showHeader={false}/> */}
          <img className="w-full hidden lg:block" height={400} src={'https://ik.imagekit.io/teh6pz4rx/adboard-booking-web/1749372011148.jpeg?updatedAt=1749710688714'} alt="Billboard banner" />
        </div>
      </div>

      <div className="hidden lg:block z-10 mb-12 lg:mb-0 lg:-mt-40 w-full">
        <HeroSearchForm />
      </div>
    </div>
  );
};

export default SectionHero2;
